import './modal.css';
import { ReactComponent as CloseIcon } from '../../../assets/close.svg';
import { useModal } from '../../../contexts/modal-context';
import * as cn from 'classnames';

export const Modal = ({ id, headerLabel, children, footer }) => {
  const { isOpen, setOpen } = useModal();

  return (
    <div className={cn(['modal-backdrop', isOpen(id) ? 'visible' : ''])}>
      <div className="modal-frame">
        <div className="modal-header">
          <div className="modal-header-content">{headerLabel}</div>
          <div className="modal-close" onClick={() => setOpen(id, false)}>
            <CloseIcon />
          </div>
        </div>
        <div className="modal-body">{children}</div>
        <div className="modal-footer">{footer}</div>
      </div>
      {/* )} */}
    </div>
  );
};
